export type Theme = 'light' | 'dark';

const KEY = 'kfh-theme';
const media = () => window.matchMedia('(prefers-color-scheme: dark)');

/** Call before first render. Stored preference wins; otherwise follow the OS. */
export function initTheme(): void {
  const stored = localStorage.getItem(KEY) as Theme | null;
  document.documentElement.dataset.theme = stored ?? (media().matches ? 'dark' : 'light');
  media().addEventListener('change', (e) => {
    if (!localStorage.getItem(KEY)) {
      document.documentElement.dataset.theme = e.matches ? 'dark' : 'light';
    }
  });
}

export function toggleTheme(): Theme {
  const next: Theme = document.documentElement.dataset.theme === 'dark' ? 'light' : 'dark';
  document.documentElement.dataset.theme = next;
  localStorage.setItem(KEY, next);
  return next;
}

export function getTheme(): Theme {
  return document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light';
}
